import StyleSheet from '../../utils/helpers/styleSheet'
import {v4 as uuidv4} from 'uuid'
import {origo} from '../../utils/helpers/origo'
import {useAppDispatch, useAppSelector} from '../../stores/configureStore'
import {
  addImageHistoryItem,
  addImageSelected,
} from '../../stores/editor/editor.reducer'
import {ImgMasked} from '../../models/editor/imgMasked'
import {IMG_ADDED} from '../../models/editor/imgHistoryItemAction'
import {useState} from 'react'
import {Select} from '../global/Select'
import {Config} from '../../constants/Config'
import {useTranslation} from 'react-i18next'

const styles: StyleSheet = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  imagesContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, calc(50% - 0.5px))',
    gridGap: 1,
  },
  imageWrapper: {
    padding: 15,
    backgroundColor: 'white',
  },
  image: {
    width: '100%',
    aspectRatio: '10/6',
    objectFit: 'contain',
    cursor: 'pointer',
  },
}

type GraphicsProps = {
  color: string
}

export default function Graphics({color}: GraphicsProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {graphics, graphicCategories} = useAppSelector(store => store.toolbox)
  const {printArea} = useAppSelector(store => store.editor)
  const [category, setCategory] = useState('all')
  return (
    <div style={styles.container}>
      <div className="categoryContainer">
        <p className="categoryText">{t('Kategóriák')}</p>
        <div className="selectWrapper">
          <Select
            onChange={e => setCategory(e.target.value)}
            value={category}
            options={[
              {value: 'all', text: t('Összes')},
              ...graphicCategories.map(item => ({
                value: item.text,
                text: item.text,
              })),
            ]}
          />
        </div>
      </div>
      <div style={styles.imagesContainer} className="imagesContainer">
        {graphics
          .filter(graphic =>
            category === 'all' ? true : graphic.category === category,
          )
          .map((item, index) => (
            <div
              style={{...styles.imageWrapper, backgroundColor: color}}
              key={`toolboxGraphic_${index}`}>
              <img
                style={{
                  ...styles.image,
                }}
                src={item.previewImage}
                alt=""
                loading="lazy"
                onClick={() => {
                  const newImg: ImgMasked = {
                    id: uuidv4(),
                    type: 'masked',
                    url: item.image,
                    position: printArea?.position ?? origo,
                    width: item.width,
                    height: item.height,
                    scale: 2,
                    rotation: 0,
                    brightness: 1,
                    mirroredX: false,
                    mirroredY: false,
                    inert: false,
                    locked: false,
                    filters: {
                      inverse: false,
                      monochrome: false,
                      sepia: false,
                    },
                    inside: item.masks.map(mask => ({
                      maskUrl: mask.image,
                      black: mask.black,
                      position: origo,
                      scale: 2,
                      url: `${Config.websiteUrl}/wp-content/themes/poloforma/assets/mask_placeholder.png`,
                    })),
                    captionsScale: item.captionsScale,
                    captions: item.captions.map(caption => ({
                      id: uuidv4(),
                      type: 'caption',
                      position: caption.position,
                      caption1: t('Szöveg helye'),
                      caption2: null,
                      width: 1000,
                      height: caption.height,
                      fontFamily: caption.fontFamily,
                      color: caption.color,
                      bold: caption.bold,
                      italic: caption.italic,
                      underline: caption.underline,
                      scale: caption.scale,
                      rotation: caption.rotation,
                      brightness: caption.brightness,
                      mirroredX: caption.mirroredX,
                      mirroredY: caption.mirroredY,
                      inert: true,
                      locked: true,
                      curvatureLevel: caption.curvatureLevel,
                      letterSpacing1: caption.letterSpacing,
                      letterSpacing2: 0,
                      filters: caption.filters,
                    })),
                  }
                  dispatch(addImageSelected({image: newImg}))
                  dispatch(
                    addImageHistoryItem({
                      item: {img: newImg, action: IMG_ADDED},
                    }),
                  )
                }}
              />
            </div>
          ))}
      </div>
    </div>
  )
}
